import type { ReactNode, ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminSession } from './useAdminSession.js';

interface RequireAdminProps {
  children: ReactNode;
}

export function RequireAdmin({ children }: RequireAdminProps): ReactElement {
  const session = useAdminSession();
  const location = useLocation();

  if (session.status === 'loading') {
    return <div className="loading" data-testid="auth-loading">Verificando sesión…</div>;
  }
  if (session.status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (session.status === 'forbidden') {
    return (
      <div className="login-screen" data-testid="auth-forbidden">
        <div className="login-card">
          <div className="login-brand">
            <span className="sidebar-brand-dot" />
            <span>Acceso denegado</span>
          </div>
          <p className="tt-sec">
            Tu cuenta (<span className="mono">{session.user.email}</span>) no tiene rol admin o
            support. Pedile a alguien con permiso que promueva tu cuenta en la DB.
          </p>
        </div>
      </div>
    );
  }
  if (session.status === 'unavailable') {
    return (
      <div className="login-screen" data-testid="auth-unavailable">
        <div className="login-card">
          <div className="login-brand">
            <span className="sidebar-brand-dot" />
            <span>Backoffice no disponible</span>
          </div>
          <p className="tt-sec">
            Tu sesión (<span className="mono">{session.user.email}</span>) está bien, pero la API
            del backoffice respondió <span className="mono">HTTP {session.httpStatus}</span>. No es
            tu rol: es el backend. Un {session.httpStatus === 404 ? '404' : 'error'} acá suele
            significar que el árbol <span className="mono">/api/admin/*</span> no está montado —
            con <span className="mono">NODE_ENV=production</span> hace falta{' '}
            <span className="mono">ADMIN_ENABLED=true</span>.
          </p>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
